import { render, staticRenderFns } from "./ProductPlayer.vue?vue&type=template&id=c412bf4e&scoped=true&"
import script from "./ProductPlayer.vue?vue&type=script&lang=js&"
export * from "./ProductPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ProductPlayer.vue?vue&type=style&index=0&id=c412bf4e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c412bf4e",
  null
  
)

export default component.exports